<div class="agpr-themePostFeed">
    <h2 class="u-srOnly">
        {{
            currentTheme
                ? ("Social.intelligence.theme.postFeed.heading"
                  | localize : { name: currentTheme.name })
                : ("Social.intelligence.archive.postFeed.heading" | localize)
        }}
    </h2>
    <div
        class="agpr-themePostFeed-toolbar"
        role="group"
        [attr.aria-label]="
            'Social.intelligence.theme.postFeed.toolbar.control' | localize
        "
    >
        <h3 class="u-srOnly">{{ "toolbar" | localize }}</h3>
        <agpr-message
            *ngIf="isArchiveSearch"
            [severity]="messageSeverity.info"
            [style]="agprComponentStyle.social"
        >
            {{ "Social.agentWidget.archiveSearch.results.message" | localize }}
        </agpr-message>
        <!-- First Row -->
        <div
            class="agpr-themePostFeed-toolbar-topRow agpr-themePostFeed-toolbar-row"
        >
            <!-- Filter -->
            <agpr-social-filter-input
                [id]="id + '_filterInput'"
                class="agpr-themePostFeed-toolbar-filter"
                [showQuickFilter]="true"
                quickFilterPlaceholder="Social.filter.quickFilter.placeholder"
                [style]="agprComponentStyle.socialPlus"
                iconClass="fa-regular fa-duotone fa-filter"
                [ariaDescribedBy]="'theme.filters'"
            ></agpr-social-filter-input>
            <!-- Date -->
            <agpr-date-query-popup
                [id]="id + '_dateInput'"
                class="agpr-themePostFeed-toolbar-dateFilter"
                [(ngModel)]="searchDateRange"
                [options]="dateOptions"
                [toolTipLabel]="'Common.dateQueryInput.dateFilter'"
                [searchRange]="searchRange"
                [style]="agprComponentStyle.socialPlus"
                (ngModelChange)="dateRangeChanged($event)"
            >
            </agpr-date-query-popup>
            <div class="agpr-themePostFeed-toolbar-sortAndViewContainer">
                <!--  Sort Tool -->
                <agpr-mentions-sort-order
                    [id]="id + '_sortOrder'"
                    class="agpr-themePostFeed-toolbar-sortTool"
                    [style]="agprComponentStyle.socialPlus"
                >
                </agpr-mentions-sort-order>
                <agpr-icon-dropdown
                    [id]="id + '_viewOptions'"
                    displayIcon="fa-regular fa-duotone fa-wrench"
                    [agprStyle]="agprComponentStyle.socialPlus"
                    [options]="mentionViewOptions"
                    inputTooltip="Social.postViewSettings"
                    [keepSelectedValue]="false"
                    [(ngModel)]="selectedMentionViewOption"
                    (ngModelChange)="selectMentionViewOption()"
                    ariaLabel="Social.postFeed.feedViewOptions"
                ></agpr-icon-dropdown>
                <agpr-social-post-save-tool
                    *ngIf="hasMonitoring"
                    [id]="id + '_savingTool'"
                    class="agpr-themePostFeed-toolbar-saveTool"
                    [selectedMentions]="selectedMentions"
                    [disabled]="allSelected"
                    (folderChanged)="folderChanged($event)"
                ></agpr-social-post-save-tool>
            </div>
        </div>

        <div
            class="agpr-themePostFeed-toolbar-middleRow agpr-themePostFeed-toolbar-row"
        >
            <agpr-filter-chips
                [id]="id + '_filters'"
                [style]="agprComponentStyle.social"
                [noContainerWhenEmpty]="true"
            ></agpr-filter-chips>
            <div
                class="agpr-themePostFeed-engagementInsightSwitch"
                *ngIf="isArchiveSearch"
            >
                <agpr-social-switch
                    [(ngModel)]="enableEngagementInsights"
                    (ngModelChange)="switchClick()"
                    onText="Social.agentWidget.archiveSearch.results.enableEngagement.label"
                    offText="Social.agentWidget.archiveSearch.results.enableEngagement.label"
                    iconTooltip="Social.agentWidget.archiveSearch.results.enableEngagement.tooltip"
                    [isArchiveSearch]="true"
                    [id]="id + '_enableEngagementInsightsSwitch'"
                ></agpr-social-switch>
            </div>
        </div>

        <div
            class="agpr-themePostFeed-toolbar-bottomRow agpr-themePostFeed-toolbar-row"
        >
            <agpr-checkbox
                [id]="id + '_toggleSelectAll'"
                [binary]="true"
                hiddenLabel="selectAll"
                [disabled]="!mentions?.length"
                [ngModel]="
                    mentions.length > 0 &&
                    selectedMentions.length === mentions.length
                "
                (ngModelChange)="toggleSelectAll()"
            >
                <div class="agpr-themePostFeed-toolbarColumn">
                    <span class="agpr-themePostFeed-totalCount">
                        <span class="agpr-themePostFeed-bold">
                            {{
                                allSelected
                                    ? mentionCount
                                    : selectedMentions.length
                            }}
                        </span>
                        <span>{{ "Social.postFeed.of" | localize }}</span>
                        <span class="agpr-themePostFeed-bold">
                            {{ mentionCount }}
                        </span>
                        <span
                            *ngIf="mentionCount > MAX_API_POSTS"
                            role="img"
                            [id]="id + '_mentionCount'"
                            class="fa-regular fa-circle-info agpr-themePostFeed-infoIcon"
                            agprTooltip="Social.postFeed.error.apiLimit"
                        ></span>
                        {{ "Social.postFeed.mentionCount" | localize }}
                    </span>
                </div>
            </agpr-checkbox>
            <div class="agpr-themePostFeed-paginator">
                <agpr-paginator
                    [id]="id + '_paginator'"
                    [maxNumberOfItems]="maxMentionCountLimit"
                    [isDisabled]="!mentions?.length"
                    [style]="agprComponentStyle.social"
                >
                </agpr-paginator>
            </div>
        </div>

        <agpr-message
            *ngIf="
                mentions?.length > 0 &&
                selectedMentions.length === mentions.length
            "
            class="agpr-themePostFeed-selectAll"
            severity="info"
            [style]="agprComponentStyle.social"
        >
            <span *ngIf="!allSelected">
                {{
                    "Social.postFeed.selectAll.page"
                        | localize
                            : {
                                  count: selectedMentions.length
                              }
                }}
            </span>
            <span *ngIf="allSelected">
                {{
                    "Social.postFeed.selectAll.all"
                        | localize
                            : {
                                  count: mentionCount
                              }
                }}
            </span>
            <agpr-button
                *ngIf="!allSelected"
                [label]="
                    'Social.postFeed.selectAll.page.action'
                        | localize
                            : {
                                  count: mentionCount
                              }
                "
                (click)="selectAllResults()"
                [style]="buttonTypes.link"
                class="agpr-themePostFeed-selectAllButton"
            ></agpr-button>
            <agpr-button
                *ngIf="allSelected"
                label="Social.postFeed.selectAll.all.action"
                (click)="toggleSelectAll()"
                [style]="buttonTypes.link"
                class="agpr-themePostFeed-selectAllButton"
            ></agpr-button>
        </agpr-message>

        <div
            *ngIf="!isArchiveSearch"
            class="agpr-themePostFeed-toolbar-quotaExceededBanner"
        >
            <agpr-quota-exceeded-banner
                [id]="'postFeed_quotaBanner'"
            ></agpr-quota-exceeded-banner>
        </div>
        <div
            *ngIf="mentions?.length === 0 && !isLoadingMentions"
            class="agpr-themePostFeed-message"
        >
            <agpr-message
                *ngIf="!filterApplied && !isArchiveSearch"
                [severity]="messageSeverity.info"
                [style]="agprComponentStyle.social"
            >
                {{ "Social.postFeed.ingestInfo" | localize }}
            </agpr-message>
            <agpr-message
                [severity]="messageSeverity.noContent"
                [style]="agprComponentStyle.social"
                [useWhiteBg]="true"
            >
                {{ "Social.postFeed.noContent" | localize }}
            </agpr-message>
        </div>
    </div>
    <div
        class="agpr-themePostFeed-mentions"
        [agprLoading]="isLoadingMentions"
        role="feed"
        [attr.aria-label]="'Social.intelligence.theme.postFeed' | localize"
        [attr.aria-busy]="isLoadingMentions"
        tabindex="0"
        (keydown)="onKeydown($event)"
    >
        <agpr-scroll-panel #scrollPanel>
            @if (errorType === errorTypes.filters && filterError) {
            <div class="agpr-themePostFeed-filtersError">
                @if (filterError.filterTypes) {
                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ "Monitoring.result.filterError" | localize }}
                    <ul class="agpr-themePostFeed-filtersErrorList">
                        <li *ngFor="let filterType of filterError.filterTypes">
                            {{
                                "Monitoring.filtersLocalization." + filterType
                                    | localize
                            }}
                            @if (filterError.localizedInvalidValueMap) {
                            <ng-container
                                >:
                                {{
                                    filterError.localizedInvalidValueMap
                                        .get(filterType)
                                        .join(", ")
                                }}</ng-container
                            >
                            }
                        </li>
                    </ul>
                </agpr-message>
                } @else {
                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ "Monitoring.result.filterError.generic" | localize }}
                </agpr-message>
                }
            </div>
            }
            <h3 class="u-srOnly">{{ "results" | localize }}</h3>
            <ul
                [id]="id + '_mentionsList'"
                class="agpr-themePostFeed-mentionsWrapper"
                agprListKeyboardNavigation
                [list]="mentions"
            >
                <li
                    #mentionsList
                    *ngFor="let mention of mentions; index as i"
                    class="agpr-themePostFeed-mention"
                    [attr.aria-labelledby]="
                        'themePostFeed.mentionHeadlineId.' + i
                    "
                    [attr.aria-setsize]="mentions.length"
                    [attr.aria-posinset]="i + 1"
                >
                    <span [id]="id + '_mentionHeadlineId_' + i" class="sr-only">
                        {{
                            mention.headline
                                ? mention.headline
                                : ("MediaType." + mention.mediaType.id | localize) +
                                  ("Mention.postBy" | localize) +
                                  mention.author.name
                        }}
                    </span>
                    <agpr-social-post-feed-card
                        [index]="
                            showPostIndex ? i + 1 + mentionIndexOffset : null
                        "
                        [id]="id + '_card_' + i"
                        [mention]="mention"
                        [showImages]="showMedia"
                        [showCheckbox]="true"
                        [selectedResults]="selectedMentions"
                        [allSelected]="allSelected"
                        [showPublishedDate]="showPublishedDate"
                        [highlightKeywords]="highlightKeywords"
                        [selectedFolder]="selectedFolder"
                        (selectionChanged)="updatePostSelection($event)"
                    >
                    </agpr-social-post-feed-card>
                </li>
            </ul>
        </agpr-scroll-panel>
    </div>
    <agpr-action-bar
        [headingContext]="'Social.intelligence.theme.postFeed' | localize"
    >
        <ng-template #right>
            <agpr-button
                [id]="id + '.actionButton'"
                label="Social.postFeed.bulkActions.actionButtonLabel.export"
                [style]="buttonTypes.primaryB"
                (click)="openBulkActionsDialog()"
            ></agpr-button>
        </ng-template>
    </agpr-action-bar>
</div>
